export class QueryParams {
  resolution?: string = '';
  aggregation?: string = '';
  aggregation_scope?: string = '';
  aggregation_method?: string = '';
  nv_default?: string = 'nv';
  unit?: string = '';
  currency?: string = '';
  timezone?: string = '';
  latest_price?: boolean = false;
  auto_update?: boolean = false;
  max_version?: string | number = '';
  start_of_day: number | null = null;

  constructor(
    resolution?: string,
    aggregation?: string,
    aggregation_scope?: string,
    aggregation_method?: string,
    nv_default?: string,
    unit?: string,
    currency?: string,
    timezone?: string,
    latest_price?: boolean,
    auto_update?: boolean,
    max_version?: string | number,
    start_of_day?: number
  ) {
    this.resolution = resolution ? resolution : this.resolution;
    this.aggregation = aggregation ? aggregation : this.aggregation;
    this.aggregation_scope = aggregation_scope
      ? aggregation_scope
      : this.aggregation_scope;
    this.aggregation_method = aggregation_method
      ? aggregation_method
      : this.aggregation_method;
    this.nv_default = nv_default !== undefined ? nv_default : this.nv_default;
    this.unit = unit ? unit : this.unit;
    this.currency = currency ? currency : this.currency;
    this.timezone =
      timezone !== undefined && timezone !== null ? timezone : this.timezone;
    this.latest_price = latest_price ? latest_price : this.latest_price;
    this.auto_update = auto_update ? auto_update : this.auto_update;
    this.max_version = max_version ? max_version : this.max_version;
    this.start_of_day = start_of_day ?? this.start_of_day;
  }
}
